import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-asp-replace-wishlist-popup',
  templateUrl: './asp-replace-wishlist-popup.component.html',
  styleUrls: ['./asp-replace-wishlist-popup.component.scss']
})
export class AspReplaceWishlistPopupComponent implements OnInit {
  showReplaceWishlistPopup: boolean = true;
  currentCarLabel: string = '';
  newCarLabel: string = '';
  currentWishlistItems: number = 0;
  currentCarStatus: string = '';
  newCarItems: number = 0;

  // ✅ NEW: actual item names
  currentWishlistItemNames: string = '';
  newWishlistItemNames: string = '';

  constructor(
    public dialogRef: MatDialogRef<AspReplaceWishlistPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {
    this.currentCarLabel = data?.currentCarLabel || '';
    this.newCarLabel = data?.newCarLabel || '';

    this.currentWishlistItems = data?.currentWishlistItems || 0;
    this.currentCarStatus = data?.currentCarStatus || 'Items Added';

    this.newCarItems = data?.newCarItems || 0;

    // ✅ Build the "current car" item names from what's already saved in the wishlist
    this.currentWishlistItemNames = this.getCurrentWishlistItemNames();

    // ✅ Build the "new car" item name(s) from the pending item waiting to be added
    this.newWishlistItemNames = data?.pendingItemName || this.getPendingWishlistItemName();
  }

  ngOnInit(): void {}

  /** Reads names of items currently sitting in the wishlist for the OLD car */
  private getCurrentWishlistItemNames(): string {
    const raw = localStorage.getItem('addedWishlist');
    if (!raw) return '';

    try {
      const parsed = JSON.parse(raw);
      const itemsObj = parsed?.[0] || {};
      const names = Object.values(itemsObj)
        .map((item: any) => item?.name)
        .filter(Boolean);

      if (names.length === 0) return '';
      if (names.length <= 2) return names.join(', ');
      // e.g. "Brake Pad, Air Filter +3 more"
      return `${names.slice(0, 2).join(', ')} +${names.length - 2} more`;
    } catch (err) {
      console.error('Error parsing addedWishlist for names:', err);
      return '';
    }
  }

  /** Reads the name of the item waiting to be added for the NEW car */
  private getPendingWishlistItemName(): string {
    const raw = localStorage.getItem('pendingWishlistItem');
    if (!raw) return '1 Part';

    try {
      const item = JSON.parse(raw);
      return item?.name || '1 Part';
    } catch (err) {
      console.error('Error parsing pendingWishlistItem for name:', err);
      return '1 Part';
    }
  }

  closeReplacePopup() {
  this.dialogRef.close({ action: 'close' });
}

keepCurrentWishlist() {
  this.dialogRef.close({ action: 'keep' });
}

  replaceWishlist() {
    // ✅ IMPORTANT: actually perform the replace before navigating away,
    // otherwise you're just closing the dialog with no state change.
    // this.performReplace();

    // this.dialogRef.close({ action: 'replace' });
    // this.router.navigate(['/request-wishlist']).then(() => {
    //   window.location.reload();
    // });
     this.dialogRef.close({ action: 'replace' });
  }

  /** Clears old car's wishlist and commits the pending item as the new wishlist */
  /** Clears old car's wishlist and commits the pending item as the new wishlist */
  // private performReplace(): void {
  //   const pendingRaw = localStorage.getItem('pendingWishlistItem');

  //   if (!pendingRaw) {
  //     console.error('[ReplaceWishlist] No pendingWishlistItem found in localStorage — nothing to replace.');
  //     return;
  //   }

  //   try {
  //     const item = JSON.parse(pendingRaw);

  //     if (!item?.key) {
  //       console.error('[ReplaceWishlist] pendingWishlistItem has no key, aborting replace:', item);
  //       return;
  //     }

  //     if (!item.cart_qty || item.cart_qty < 1) {
  //       item.cart_qty = 1;
  //     }

  //     const newData: any = { [item.key]: item };

  //     localStorage.setItem('addedWishlist', JSON.stringify([newData]));
  //     localStorage.removeItem('pendingWishlistItem');
  //   } catch (err) {
  //     console.error('Error replacing wishlist:', err);
  //   }
  // }
}